import React, { useEffect, useState } from 'react';
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckDataAccount, apiFormUpdateAccount } from "../../services/api.service.js";


import { Close } from "@mui/icons-material";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmSMS, setOpenConfirmSMS] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });


  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value.toLowerCase();
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };

  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    if (name === "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew)
          break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove)
          break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank)
          break;
        default: setDesChangeBank(originalDesChangeBank)
      }
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, [typeModal]);

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!dataCheck.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if ( data.phone_number) {
      if (!dataCheck.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(dataCheck.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Kiểm tra trường email
    if ( data.email) {
      if (!dataCheck.email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email';
      } else if (!/\S+@\S+\.\S+/.test(dataCheck.email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!dataCheck.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng nhập Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!dataCheck.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
        if (!dataUpdate.name) {
          formIsValid = false;
          errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
        } else {
          contentUpdate = dataUpdate.name;
        }
        break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng nhập Ngân Hàng mới';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
        } else {
          contentUpdate = (dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name)
        }
        break;
      case "birthday": // Kiểm tra trường birth day
        if (!dataUpdate.birth_day) {
          formIsValid = false;
          errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
        } else {
          contentUpdate = dataUpdate.birth_day;
        }
        break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };

  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };

  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false)
    if (updateInfo) {
      setCheckConfirm(true); // Set checkConfirm = true khi thành công
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, submit) => {
    if (validateForm()) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...dataCheck,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && !submit) {
          // Comment lại vì không sử dụng descriptionFileUpload nữa
          // let descriptionFileUpload = "Bạn vui lòng tải lên ít nhất 3 trong " + webSetting?.des_up_files?.length + " hình ảnh/video dưới để xác minh tài khoản<br/><br/>";
          // if (webSetting?.des_up_files?.length > 0) {
          //   webSetting?.des_up_files?.forEach(element => {
          //     descriptionFileUpload += (element) ? "" + element + "</br>" : ""
          //   });
          // }
          // descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setOpenUploadFile(true);
          return;
        }
        // phần này lỗi không gửi submit
        // if (type === "phone_number" && !submit) {
        //   setOpenConfirmSMS(true);
        //   return;
        // }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit > 0)) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: (checkDataOld.countMatch / checkDataOld.count < 0.5) ? "error" : "warning",
            title: "Chú ý",
            text: (checkDataOld.allowSubmit === 0 && type !== 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch / checkDataOld.count * 100) + "%",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: 'Tiếp tục gửi',
            // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
            showConfirmButton: (type === 'files' || checkDataOld.allowSubmit > 0),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData(timesCheckData + 1)
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    navigate("/profile", { state: { userName, data, webSetting } }); 
  };

  const closeModalConfirmSMS = () => {
    setOpenConfirmSMS(false);
    navigate("/profile", { state: { userName, data, webSetting } }); 
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 3 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 3MB.`,
        });
        return false;
      }
      return true;
    });

    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <>
      {loading && <Loading loading={loading} />}
      <motion.div
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        className="overflow-x-hidden"
      >
        <div className="w-full max-w-[640px] max-[640px]:max-w-[480px] max-[375px]:max-w-[320px] mx-auto p-0 sm:p-4 md:p-5 rounded-[20px]">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="relative w-full rounded-[20px] bg-transparent tracking-wide flex flex-col justify-start items-center gap-2 !pt-0 p-3 sm:p-4 md:p-5"
          >
            <div className="w-full h-fit flex justify-center items-center">
              <img
                src="/search/title-sup-cskh.png"
                alt="logo"
                className="w-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] h-auto object-contain"
              />
            </div>

            <p className="block mt-2 sm:mt-2.5 mb-3 sm:mb-4 tracking-wide text-[#1F1F1F] text-center font-inter text-[16px] sm:text-[18px] md:text-[20px] font-bold uppercase leading-[24px] sm:leading-[28px] px-1">
              THÔNG TIN CÁ NHÂN
            </p>

            <div className="w-full rounded-[16px] bg-transparent px-2 sm:px-2.5">
              <InfoUser />
            </div>

            <div className="w-full rounded-[16px] bg-transparent px-2 sm:px-2.5 mt-3 sm:mt-4">
              <div className="w-full max-w-[640px] mx-auto text-left">
                <span
                  className="block mt-2 sm:mt-2.5 mb-3 sm:mb-4 tracking-wide text-[#1F1F1F] text-center font-inter text-[16px] sm:text-[18px] md:text-[20px] font-bold uppercase leading-[24px] sm:leading-[28px] px-1"
                >
                  VUI LÒNG NHẬP LẠI <br className="sm:hidden" />THÔNG TIN ĐÃ LIÊN KẾT
                </span>
                <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="name"
                    value={dataCheck.name}
                    onChange={inputDataCheck}
                    placeholder="Họ Và Tên"
                    className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm  focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                </div>
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="phone_number"
                    value={dataCheck.phone_number}
                    onChange={inputDataCheck}
                    placeholder="Số Điện Thoại"
                    className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm  focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                  />
                  {errors.phone_number && <p className="text-red-500 text-sm mt-1">{errors.phone_number}</p>}
                </div>
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="email"
                    value={dataCheck.email}
                    onChange={inputDataCheck}
                    placeholder="Email"
                    className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm  focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>
                <div className="flex flex-col">
                  <select
                    name="bank_name"
                    value={dataCheck.bank_name}
                    onChange={inputDataCheck}
                    className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm  focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                  >
                    <option value="" className="text-[#8e8e8e] text-xs sm:text-sm">Chọn Ngân Hàng</option>
                    {config.LIST_BANK_NAME.map((bank, index) => (
                      <option key={index} value={bank} className="bg-white text-[#F27121]">
                        {bank}
                      </option>
                    ))}
                  </select>
                  {errors.bank_name && <p className="text-red-500 text-sm mt-1">{errors.bank_name}</p>}
                </div>
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="bank_number"
                    value={dataCheck.bank_number}
                    onChange={inputDataCheck}
                    placeholder="Số Tài Khoản"
                    className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm  focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                  />
                  {errors.bank_number && <p className="text-red-500 text-sm mt-1">{errors.bank_number}</p>}
                </div>
              </div>
              </div>
            </div>

            <div className="w-full rounded-[16px] bg-transparent px-2 sm:px-2.5 mt-2 sm:mt-2.5">
              <div className="w-full max-w-[640px] mx-auto text-left">
              {
                {
                  "full_name":
                    <>
                      <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#0053DF] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1">
                        THAY ĐỔI HỌ TÊN MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="name"
                            onChange={inputDataUpdate}
                            placeholder="Họ Tên Mới"
                            className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm  focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          />
                          {errors.nameUpdate && <p className="text-red-500 text-sm mt-1">{errors.nameUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "phone_number":
                    <>
                      <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#0053DF] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1">
                        THAY ĐỔI SỐ ĐIỆN THOẠI MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="phone_number"
                            onChange={inputDataUpdate}
                            placeholder="Số Điện Thoại Mới"
                            className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          />
                          {errors.phoneNumberUpdate && <p className="text-red-500 text-sm mt-1">{errors.phoneNumberUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "email":
                    <>
                      <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#0053DF] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1">
                        THAY ĐỔI EMAIL MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="email"
                            onChange={inputDataUpdate}
                            placeholder="Email Mới"
                            className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          />
                          {errors.emailUpdate && <p className="text-red-500 text-sm mt-1">{errors.emailUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "bank":
                    <>
                      <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#0053DF] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1">
                        {desChangeBank.title_change_bank}
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <select
                            type="input"
                            name="bank_type_change"
                            onChange={inputDataUpdate}
                            className="px-4 py-3 pr-10 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%236B7280\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e')] bg-no-repeat bg-[right_12px_center] bg-[length:16px_16px] focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          >
                            <option value="" className="text-[#8e8e8e] text-xs sm:text-sm">Chọn yêu cầu thay đổi</option>
                            {config.LIST_REQUEST_BANK.map((bank, index) => (
                              <option key={index} value={bank} className="bg-white text-black">
                                {bank}
                              </option>
                            ))}
                          </select>
                          {errors.bankTypeChange && <p className="text-red-500 text-sm mt-1">{errors.bankTypeChange}</p>}
                        </div>
                        <div className="flex flex-col">
                          <select
                            name="bank_name"
                            onChange={inputDataUpdate}
                            className="px-4 py-3 pr-10 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%236B7280\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e')] bg-no-repeat bg-[right_12px_center] bg-[length:16px_16px] focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          >
                            <option value="" className="text-[#8e8e8e] text-xs sm:text-sm">Chọn Ngân Hàng Mới</option>
                            {config.LIST_BANK_NAME.map((bank, index) => (
                              <option key={index} value={bank} className="bg-white text-black">
                                {bank}
                              </option>
                            ))}
                          </select>
                          {errors.bankNameUpdate && <p className="text-red-500 text-sm mt-1">{errors.bankNameUpdate}</p>}
                        </div>
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="bank_number"
                            onChange={inputDataUpdate}
                            placeholder={desChangeBank.bank_number}
                            className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black placeholder:text-black placeholder:text-xs sm:placeholder:text-sm focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          />
                          {errors.bankNumberUpdate && <p className="text-red-500 text-sm mt-1">{errors.bankNumberUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "birthday":
                    <>
                      <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#0053DF] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1">
                        THAY ĐỔI NGÀY SINH MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="date"
                            name="birth_day"
                            onChange={inputDataUpdate}
                            placeholder="ngày tháng năm sinh"
                            defaultValue="2000-12-01"
                            className="px-4 py-3 outline-none bg-white rounded-full border border-[#6B7280] text-[12px] md:text-[14px] font-medium text-black focus:border-[#1E6FFF] focus:ring-1 focus:ring-[#1E6FFF] transition-all"
                          />
                          {errors.birthDayUpdate && <p className="text-red-500 text-sm mt-1">{errors.birthDayUpdate}</p>}
                        </div>
                      </div>
                    </>,
                }[typeModal]
              }
              </div>
            </div>
            <div className="w-[95%] sm:w-[90%] mx-2 sm:mx-3 md:mx-4 mb-3 sm:mb-4 mt-2 sm:mt-2.5 text-left">
              <span className="block mt-2 sm:mt-2.5 mb-3 sm:mb-4 tracking-wide text-[#1F1F1F] text-center font-inter text-[16px] sm:text-[18px] md:text-[20px] font-bold uppercase leading-[24px] sm:leading-[28px] px-1">
                VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC
              </span>
              <div className="flex gap-3 sm:gap-4 justify-center items-center mt-3 sm:mt-4">
                {data.email &&
                  <button
                    onClick={() => updateUser("mail")}
                    className="cursor-pointer inline-flex items-center justify-center flex-1 max-w-[48%] [&>img]:object-contain [&>img:hover]:scale-[1.02] [&>img:hover]:transition-transform [&>img:hover]:duration-200 [&>img:active]:scale-95"
                  >
                    <img src="/button/bt-sub-email.png" alt="img-sub-email" className="w-full h-auto" />
                  </button>
                }
                {data.phone_number &&
                  <button
                    onClick={() => updateUser("phone_number")}
                    className="cursor-pointer inline-flex items-center justify-center flex-1 max-w-[48%] [&>img]:object-contain [&>img:hover]:scale-[1.02] [&>img:hover]:transition-transform [&>img:hover]:duration-200 [&>img:active]:scale-95"
                  >
                    <img src="/button/bt-sub-phone.png" alt="img-sub-phone" className="w-full h-auto" />
                  </button>
                }
              </div>

              {/* <p className="text-sm sm:text-base text-[#2F3945] text-center mt-4 sm:mt-5 mb-3 sm:mb-4 leading-relaxed px-2">
                Nếu quý khách không còn sử dụng email hoặc SĐT đăng ký trong tài khoản game, vui lòng chọn nút dưới đây để thực hiện thay thế
              </p>

              <div className="flex justify-center mt-3 sm:mt-4">
                <button
                  onClick={() => setOpenUploadFile(true)}
                  className="cursor-pointer inline-flex items-center justify-center gap-3 w-full max-w-[450px] px-6 py-1 sm:py-4 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm sm:text-base md:text-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl "
                >
                  <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span>TẢI LÊN HÌNH ẢNH THAY THẾ XÁC THỰC</span>
                </button>
              </div> */}
            </div>
          </motion.div>
        </div>

        {/* Modal Confirm */}
        <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
          <motion.div
            initial={{ opacity: 0, y: 75 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white max-w-[480px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative border border-[#E5E5E5] shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
          >
            {/* Close button - Red X lớn */}
            <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-[99]">
              <button
                className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-transparent border-none cursor-pointer p-0 hover:opacity-70 transition-opacity"
                onClick={closeModalConfirm}
              >
                <span className="text-red-500 text-2xl sm:text-3xl font-bold leading-none">×</span>
              </button>
            </div>

            {user.send_type === 'files' ? (
              <div className="flex flex-col items-center justify-center text-center p-4 sm:p-5 md:p-6 pt-6 sm:pt-8">
                <img className="mb-4 sm:mb-5 md:mb-6 w-16 h-16 sm:w-[72px] sm:h-[72px] md:w-20 md:h-20 object-contain" src="/icons/icon-success.png" alt="icon-success" />
                <span className="text-[13px] sm:text-[14px] md:text-[15px] lg:text-base font-medium mb-4 sm:mb-5 md:mb-6 text-[#2F3945] leading-relaxed px-2">Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.</span>
                <div className="flex justify-center gap-2.5 mt-2 w-full">
                  <a
                    href={webSetting.link_home || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="min-w-[120px] sm:min-w-[140px] border border-[#F27121] bg-gradient-to-r from-[#ff9f4d] to-[#F27121] shadow-[0px_2px_8px_rgba(242,113,33,0.35)] rounded-[20px] sm:rounded-[25px] px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 text-white text-center cursor-pointer text-xs sm:text-sm font-semibold hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] hover:scale-105 transition-all duration-200 no-underline"
                  >
                    VỀ TRANG CHỦ
                  </a>
                </div>
                <div className="bg-gradient-to-br from-[#FFF5ED] to-[#FFEBDD] border border-[#FEF1E9] rounded-[8px] sm:rounded-[10px] p-3 sm:p-3.5 md:p-4 text-[12px] sm:text-[13px] md:text-sm text-[#2F3945] mt-4 sm:mt-5 text-left w-full">
                  <p className="text-[#F27121] font-bold py-1 my-0 mb-2.5 text-sm">Lưu ý:</p>
                  <p className="my-2 px-0 leading-relaxed">- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                  <p className="my-2 px-0 leading-relaxed">- Liên hệ <a href={webSetting.link_cskh || '#'} target="_blank" rel="noopener noreferrer" className="text-[#007AFF] font-semibold no-underline hover:underline">CSKH</a> nếu cần hỗ trợ thêm.</p>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-start p-4 sm:p-5 md:p-6 pt-0">
                {/* Warning Icon - Top Left */}
                <div className="mb-4 sm:mb-5 -mt-2">
                  <div className="w-10 h-10 sm:w-16 sm:h-16 md:w-15 md:h-15 rounded-full mt-4 sm:mt-0">
                    <img src="/icons/icon-warning.png" alt="icon-warning" className="w-full h-full object-contain" />
                  </div>
                </div>

                {/* Instruction Text */}
                {isSendMail ? (
                  <p className="text-sm sm:text-[15px] md:text-base font-medium mb-3 sm:mb-4 text-[#2F3945] leading-relaxed text-left w-full">
                    Vui lòng sử dụng email đã liên kết <span className="text-[#F27121] font-semibold">{data?.email || '-'}</span> gửi tín nhân tới số email <span className="text-[#007AFF] font-semibold">{webSetting?.email || '-'}</span>, với nội dung:
                  </p>
                ) : user.send_type === 'phone_number' ? (
                  <p className="text-sm sm:text-[15px] md:text-base font-medium mb-3 sm:mb-4 text-[#2F3945] leading-relaxed text-left w-full">
                    Vui lòng sử dụng số điện thoại đã liên kết <span className="text-[#F27121] font-semibold">{data?.phone_number || '-'}</span>, gửi tin nhắn tới số điện thoại C168{" "}
                    <span className="text-[#F27121] font-semibold">{webSetting?.phone_number || '-'}</span>, với nội dung:
                  </p>
                ) : (
                  <p className="text-sm sm:text-[15px] md:text-base font-medium mb-3 sm:mb-4 text-[#2F3945] leading-relaxed text-left w-full">
                    Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.
                  </p>
                )}

                {/* Data Confirm Content */}
                <div className="w-full mb-3 sm:mb-4">
                  <DataConfirm user={user}
                    dataCheck={dataCheck}
                    dataUpdate={dataUpdate}
                    webSetting={webSetting} />
                </div>

                {/* Note Section */}
                <div className="w-full mt-4 sm:mt-5 mb-4 sm:mb-5">
                  <p className="text-[#007AFF] font-bold text-sm sm:text-base mb-2">Lưu ý:</p>
                  <ul className="list-disc list-inside space-y-1 text-sm sm:text-[15px] text-[#2F3945] leading-relaxed">
                    <li>Sau khi nhận được Email, hệ thống xét duyệt từ 2-5 phút.</li>
                    <li>Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</li>
                    <li>Liên hệ <a href={webSetting?.link_cskh || '#'} target="_blank" rel="noopener noreferrer" className="text-[#007AFF] font-semibold no-underline hover:underline">CSKH</a> nếu cần hỗ trợ thêm.</li>
                  </ul>
                </div>
              </div>
            )}
          </motion.div>
        </Popup>

        {/* Modal Confirm SMS */}
        <Popup open={openConfirmSMS} closeOnDocumentClick={false} onClose={closeModalConfirmSMS} position={"center"} nested>
          <motion.div
            initial={{ opacity: 0, y: 75 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white max-w-[480px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative border border-[#E5E5E5] shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
          >
            {/* Close button - Red X lớn */}
            <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-[99]">
              <button
                className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-transparent border-none cursor-pointer p-0 hover:opacity-70 transition-opacity"
                onClick={closeModalConfirmSMS}
              >
                <span className="text-red-500 text-2xl sm:text-3xl font-bold leading-none">×</span>
              </button>
            </div>

            <div className="flex flex-col items-start p-4 sm:p-5 md:p-6 pt-0">
              {/* Warning Icon - Top Left */}
              <div className="mb-4 sm:mb-5 -mt-2">
                <div className="w-10 h-10 sm:w-16 sm:h-16 md:w-15 md:h-15 rounded-full mt-4 sm:mt-0">
                  <img src="/icons/icon-warning.png" alt="icon-warning" className="w-full h-full object-contain" />
                </div>
              </div>

              {/* Instruction Text - SMS */}
              <p className="text-sm sm:text-[15px] md:text-base font-medium mb-3 sm:mb-4 text-[#2F3945] leading-relaxed text-left w-full">
                Vui lòng sử dụng số điện thoại đã liên kết <span className="text-[#F27121] font-semibold">{data?.phone_number || '-'}</span> gửi tin nhắn tới số điện thoại <span className="text-[#007AFF] font-semibold">{webSetting?.phone_number || '-'}</span>, với nội dung:
              </p>

              {/* Data Confirm Content */}
              <div className="w-full mb-3 sm:mb-4">
                <DataConfirm 
                  user={{...user, send_type: "phone_number"}}
                  dataCheck={dataCheck}
                  dataUpdate={dataUpdate}
                  webSetting={webSetting} 
                />
              </div>

              {/* Note Section */}
              <div className="w-full mt-4 sm:mt-5 mb-4 sm:mb-5">
                <p className="text-[#007AFF] font-bold text-sm sm:text-base mb-2">Lưu ý:</p>
                <ul className="list-disc list-inside space-y-1 text-sm sm:text-[15px] text-[#2F3945] leading-relaxed">
                  <li>Sau khi nhận được Tin nhắn, hệ thống xét duyệt từ 2-5 phút.</li>
                  <li>Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</li>
                  <li>Liên hệ <a href={webSetting?.link_cskh || '#'} target="_blank" rel="noopener noreferrer" className="text-[#007AFF] font-semibold no-underline hover:underline">CSKH</a> nếu cần hỗ trợ thêm.</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </Popup>

        {/* Modal Result */}
        {/*         <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}> */}
        <Popup open={openResult} closeOnDocumentClick={false} onClose={() => setOpenResult(false)} position={"center"} nested>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white max-w-[400px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative pb-6 sm:pb-8 md:pb-10 px-4 sm:px-6 border border-[#E5E5E5] shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
          >
            {/* Header với icon và nút đóng cùng hàng - Dính sát top */}
            <div className="flex items-center justify-between pt-4 sm:pt-4 md:pt-4 pb-4 sm:pb-6">
              <img src="/icons/icon-success.png" alt="icon-success" className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 object-contain" />
              <button
                className="flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-transparent border-none cursor-pointer p-0 hover:opacity-70 transition-opacity"
                onClick={() => setOpenResult(false)}
              >
                <span className="text-gray-700 text-xl sm:text-2xl font-bold leading-none">×</span>
              </button>
            </div>
            {checkConfirm ? (
              <div className="flex flex-col pb-4 sm:pb-6">
                {/* Title - Căn trái */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-black mb-4 sm:mb-6 text-left">Thành công !</h3>
                {/* Message - Căn trái */}
                <p className="text-sm sm:text-[15px] md:text-base text-[#2F3945] leading-relaxed text-left mb-6 sm:mb-8">
                  Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ.
                </p>
                {/* OK Button - Căn giữa */}
                <div className="flex justify-center">
                  <button
                    onClick={() => setOpenResult(false)}
                    className="w-full max-w-[90%] px-6 py-3 sm:py-3.5 rounded-lg sm:rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm sm:text-base font-bold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex flex-col pb-4 sm:pb-6">
                {/* Header với icon và nút đóng cùng hàng */}
                <div className="flex items-center justify-between mb-4 sm:mb-6">
                  {/* Warning Icon ở góc trên trái */}
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-red-500 flex items-center justify-center">
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </div>
                  {/* Close button - Dark gray X */}
                  <button
                    className="flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-transparent border-none cursor-pointer p-0 hover:opacity-70 transition-opacity"
                    onClick={() => setOpenResult(false)}
                  >
                    <span className="text-gray-700 text-xl sm:text-2xl font-bold leading-none">×</span>
                  </button>
                </div>
                {/* Title - Căn trái */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-black mb-4 sm:mb-6 text-left">Thất bại !</h3>
                {/* Message - Căn trái */}
                <p className="text-sm sm:text-[15px] md:text-base text-[#2F3945] leading-relaxed text-left mb-6 sm:mb-8">
                  Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng.
                </p>
                {/* OK Button - Căn giữa */}
                <div className="flex justify-center">
                  <button
                    onClick={() => setOpenResult(false)}
                    className="w-full max-w-[90%] px-6 py-3 sm:py-3.5 rounded-lg sm:rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm sm:text-base font-bold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            )}
          </motion.div>
        </Popup>
        {/* Modal Upload File */}
        <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white max-w-[480px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative py-4 sm:py-5 md:py-6 px-3 sm:px-4 border border-[#E5E5E5] shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
          >
            <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-[99]">
              <button
                className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-transparent border-none cursor-pointer p-0 hover:opacity-70 transition-opacity"
                onClick={() => setOpenUploadFile(false)}
              >
                <span className="text-red-500 text-2xl sm:text-3xl font-bold leading-none">×</span>
              </button>
            </div>
            <div className="flex flex-col items-start text-left pt-0">
              {/* Icon warning màu đỏ lớn */}
              <div className="mb-4 sm:mb-5 -mt-2">
                <div className="w-10 h-10 sm:w-16 sm:h-16 md:w-15 md:h-15 rounded-full  ">
                  <img src="/icons/icon-warning.png" alt="icon-warning" className="w-full h-full object-contain" />
                </div>
              </div>

              {/* Text chính */}
              <p className="text-sm sm:text-[15px] md:text-base font-semibold text-[#2F3945] leading-relaxed mb-3 sm:mb-4 px-2">
                Quý khách cần cung cấp thêm hình ảnh để xác minh thông tin.
              </p>
              <p className="text-sm sm:text-[15px] md:text-base font-medium text-[#2F3945] leading-relaxed mb-4 sm:mb-5 px-2">
                Vui lòng tải lên ít nhất 2 trong 4 hình ảnh dưới để xác minh tài khoản:
              </p>

              {/* Danh sách yêu cầu */}
              <div className="w-full text-left mb-4 sm:mb-5 px-2">
                <ol className="list-decimal list-inside space-y-2 text-sm sm:text-[15px] md:text-base text-[#2F3945] leading-relaxed">
                  <li>Hình ảnh app ngân hàng có tên chủ thẻ và STK ngân hàng đã liên kết.</li>
                  <li>Hình ảnh chụp màn hình *101# đúng SĐT đã liên kết.</li>
                  <li>Hình ảnh đăng nhập thành công Email đã liên kết.</li>
                  <li>Hình ảnh đăng nhập trang chủ Jun88 có số dư chính xác ở thời điểm hiện tại.</li>
                </ol>
              </div>

              {/* Vùng upload lớn */}
              <div className="w-full mb-4 sm:mb-5">
                <input
                  accept="image/*, video/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  type="file"
                  onChange={handleMediaUpload}
                  multiple
                />
                <label htmlFor="upload-button" className="cursor-pointer">
                  <div className="w-full min-h-[200px] sm:min-h-[250px] border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 hover:border-blue-400 transition-all flex flex-col items-center justify-center p-4 sm:p-6">
                    {previews.length > 0 ? (
                      <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 mb-4">
                        {previews.map((preview, index) => (
                          <div key={index} className="relative group">
                            {preview.type === "image" ? (
                              <img
                                src={preview.url}
                                alt={`preview-${index}`}
                                className="w-full h-32 sm:h-40 object-cover rounded-lg"
                              />
                            ) : (
                              <video
                                src={preview.url}
                                controls
                                className="w-full h-32 sm:h-40 object-cover rounded-lg"
                              />
                            )}
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleRemoveImage(index);
                              }}
                              className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <Close fontSize="small" />
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        <svg className="w-16 h-16 sm:w-20 sm:h-20 text-blue-500 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <span className="text-base sm:text-lg font-medium text-gray-600">Thêm ảnh</span>
                      </>
                    )}
                    {previews.length > 0 && (
                      <div className="mt-4">
                        <span className="text-sm sm:text-base font-medium text-blue-500">Thêm ảnh</span>
                      </div>
                    )}
                  </div>
                </label>
              </div>

              {/* Text hướng dẫn */}
              <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-5 px-2 leading-relaxed">
                Cung cấp hình ảnh dùng theo mô tả đề được xét duyệt
              </p>

              {/* Nút Hoàn thành */}
              <div className="w-full flex justify-center mt-4">
                <button
                  id="complete_files_btn"
                  onClick={() => { 
                    if (selectedImage.length >= 2) {
                      setOpenUploadFile(false); 
                      updateUser(user.send_type, true);
                    }
                  }}
                  disabled={selectedImage.length < 2}
                  className={`w-full max-w-[200px] sm:max-w-[400px] px-6 py-3 sm:py-3.5 rounded-full text-white text-sm sm:text-base font-semibold transition-all duration-300 ${
                    selectedImage.length >= 2
                      ? 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-xl cursor-pointer'
                      : 'bg-gray-300 cursor-not-allowed'
                  }`}
                >
                  Hoàn thành
                </button>
              </div>
            </div>
          </motion.div>
        </Popup>
      </motion.div>
    </>
  );
}

export default ChangeInfo;
